import { useDashboardContext } from "@/context-state/DashboardContext.jsx";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { handleError } from "@/services/errorHandler.js";
import { getCreativeReports, getIntegrations, getFolders } from "@/services/api.js";
import { MainLoader } from '@/components/loader/MainLoader.jsx'
import { useParams } from 'react-router-dom'
import { toggleLoader } from '@/hooks/useDashboardLoader.jsx'
import { useCurrentSpace } from "@/hooks/useCurrentSpace";
import { IntegrationProviders } from "@/consts";

const demoIntegrations = [
    {
        provider: IntegrationProviders.META,
        reAuthRequire: false,
        adAccounts: []
    }
]

export const DashboardDataProvider = ({ children }) => {

    const { integrationsContext, creativeContext } = useDashboardContext()

    const { updateIntegrationsState } = integrationsContext
    const { setCreativeReports, setReportFolders } = creativeContext
    const { spaceId } = useParams()
    const [isFetched, setIsFetched] = useState(false)
    const { isDemoSpace } = useCurrentSpace()

    const fetchEssentialDashboardData = async () => {
        try {
            // Get essential data for the dashboard
            const [integrationsResponse, creativeReportsResponse, foldersResponse] = await Promise.all([
                getIntegrations(),
                getCreativeReports(),
                getFolders()
            ])

            const integrations = isDemoSpace ? demoIntegrations : integrationsResponse.data

            updateIntegrationsState(integrations)
            setCreativeReports(creativeReportsResponse.data)
            setReportFolders(foldersResponse.data)

            setIsFetched(true)
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
        }
    }

    // Needs to re fetch some data each time the space changes, we're currently not saving that to local state
    const handleSpaceChanged = async () => {
        try {
            toggleLoader(true)
            const [creativeReportsResponse, foldersResponse] = await Promise.all([
                getCreativeReports(),
                getFolders()
            ])
            setCreativeReports(creativeReportsResponse.data)
            setReportFolders(foldersResponse.data)
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
        } finally {
            toggleLoader(false)
        }
    }

    useEffect(() => {
        if (!isFetched) {
            fetchEssentialDashboardData()
            return
        }
        handleSpaceChanged()
    }, [spaceId])



    return (
        isFetched ? children : <MainLoader className="bg-hero-background bg-cover bg-center bg-no-repeat" />
    )

}
